import {useContext} from 'react';
import ConfigContext from './config-context';

export default function useAutoComplete() {
    return useContext(ConfigContext).autoCompleteForms ? undefined : 'off';
}
